import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@types';

interface State {
    selectedIds: string[];
}

const initialState: State = {
    selectedIds: [],
};

export const inventoryPageSlice = createSlice({
    name: 'inventoryPage',
    initialState,
    reducers: {
        selectedIdsChanged: (state, action: PayloadAction<string[]>) => {
            state.selectedIds = action.payload;
        },
    },
});

export const inventoryPageActions = inventoryPageSlice.actions;

export const selectInventorySelectedIds = (state: RootState) => state.inventoryPage.selectedIds;
